import { PropsWithChildren, useState } from "react";
import { Box } from "@material-ui/core";
import { AppBarNav } from "./components/AppBarNav";
import { MobileDrawer } from "./components/MobileDrawer";
import { SearchDialog } from "./components/SearchDialog";
import { useStanConfig } from "./hooks/useStanConfig";
import { useAppContext } from "./hooks/useAppContext";

export const Root = ({ children }: PropsWithChildren<{}>) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const stanDisplayName = useStanConfig();
  const appContext = useAppContext();

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleSearchOpen = () => {
    setSearchOpen(true);
  };

  const handleSearchClose = () => {
    setSearchOpen(false);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <AppBarNav
        onDrawerToggle={handleDrawerToggle}
        onSearchOpen={handleSearchOpen}
        stanDisplayName={stanDisplayName}
        appContext={appContext}
      />

      <MobileDrawer
        open={drawerOpen}
        onClose={handleDrawerClose}
        stanDisplayName={stanDisplayName}
        onSearchOpen={handleSearchOpen}
        appContext={appContext}
      />

      <SearchDialog open={searchOpen} onClose={handleSearchClose} />

      <Box sx={{ flexGrow: 1, overflow: "auto" }}>{children}</Box>
    </Box>
  );
};
